import React, { useState } from "react";
import { useSelector } from "react-redux";

import {
  Typography, Container, Button,
  Box, 
} from "@mui/material";

import { i18n } from '../../translate/i18n';
import {
  FormStyled,
  DivFormTitle,
  FormNewAction,
  InputView, 
} from "./styles";

import Spinner from "../../components/Spinner/index";
import TimelineItem from "../../UI/Timeline/TimelineItem/TimelineItem";
import NewActionPostInput from '../../components/NewActionPostInput/NewActionPostInput';
import WarningImage from '../../assets/Warning.svg';
import { EAccessRole } from "../../store/types";

const styles = {
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: "relative"
  },
  iconButton: {
    marginRight: 5,
  },
  timelineTitle: {
    fontWeight: 700,
  },
  timelineContainer: {
    borderRadius: 10,
    backgroundColor: '#fff',
    padding: 10,
  },
  sendButton: {
    position: 'absolute',
    bottom: 15,
    right: 20,
    backgroundColor: '#87d299',
    color: '#000',
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 3,
  },
};

const TimelineActions = (props) => {
  console.log(props.disabled);
  const actionService = useSelector(state => state.actions.action);
  const loadingActionService = useSelector(state => state.actions.loading);
  const [showMessageInput, setShowMessageInput] = useState(false);
  const role = useSelector(state => state.auth.selectedAccess.role);

  const isContractor = role === EAccessRole.contractor;
  const isAnalyst = role === EAccessRole.analyst;
  const isAdmin = role === EAccessRole.admin;

  const handleShowMessageInput = () => {
    !props.disabled && setShowMessageInput(true);
  };

  const handleHideMessageInput = () => {
    setShowMessageInput(false);
  };

  return (
    <>
      <Container maxWidth="sm" style={styles.container}>
        <FormNewAction onClick={handleShowMessageInput}>
          <InputView placeholder={i18n.t('inputViewTimeActions.placeholder')} onChange={handleShowMessageInput} disabled={props.disabled}/>
          {/* <InputIconGroup>
            <InputIcon>
              <CameraAltOutlined style={{ color: '#87b488' }} />
              <InputIconLabel>Foto/Vídeo</InputIconLabel>
            </InputIcon>
            <InputIcon>
              <LinkOffOutlined style={{ color: '#87b488' }} />
              <InputIconLabel>Link</InputIconLabel>
            </InputIcon>
            <InputIcon>
              <AttachmentOutlined style={{ color: '#87b488' }} />
              <InputIconLabel>Anexar arquivo</InputIconLabel>
            </InputIcon>
          </InputIconGroup> */}
          <Button variant="contained" color="primary" style={styles.sendButton} disabled={props.disabled}>
            {i18n.t('buttonTimeActions.text')}
          </Button>
        </FormNewAction>
        <Box sx={{padding: '16px', borderRadius: '8px', border: '1px solid #E0E0E0', display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
          <img src={WarningImage} style={{ width: '62px', height: '40px', marginRight: '16px'}}/>
          <Box>
            { isAdmin && <Typography sx={{fontSize: '12px', color: 'rgba(16, 24, 32, 0.60)'}}>{i18n.t('typographyTimeActions.adminWarning')}</Typography> }
            { (isAdmin || isAnalyst) && <Typography sx={{ marginTop: '5px', fontSize: '12px', color: 'rgba(16, 24, 32, 0.60)'}}>{i18n.t('typographyTimeActions.analystWarning')}</Typography>}
            { (isAdmin || isContractor) && <Typography sx={{ marginTop: '5px', fontSize: '12px', color: 'rgba(16, 24, 32, 0.60)'}}>{i18n.t('typographyTimeActions.contractorWarning')}</Typography>}
          </Box>
        </Box>
        {loadingActionService && <Spinner overlay />}
        <DivFormTitle style={{opacity: loadingActionService ? "0.3" : "1"}}>
          <Typography variant="h6" style={styles.timelineTitle}>{i18n.t('typographyTimeActions.timelineTitle')}</Typography>
        </DivFormTitle>
        <div style={styles.timelineContainer}>
          <FormStyled style={{ opacity: loadingActionService ? "0.3" : "1" }}>      
            <div style={{ marginTop: "10px" }}>
              <TimelineItem timeline={actionService.timeline} />
            </div>
          </FormStyled>
        </div>
      </Container>
      {showMessageInput && <NewActionPostInput closeModal={handleHideMessageInput} />}
    </>
  );
};

export default TimelineActions;
